import { resolve } from "path";

declare var gigya: any;

export const STATUS = {
	FAIL: "FAIL",
	OK: "OK",
};

export const RESPONSE_CODES = {
	SUCCESS: 0,
	//TODO: map codes from https://help.sap.com/docs/SAP_CUSTOMER_DATA_CLOUD/8b8d6fffe113457094a17701f63e3d6a/416d41b170b21014bbc5a10ce4041860.html
};

const gigyaActions = (screenSet: string, startScreen: string, onHide?: any) => {
	gigya.accounts.showScreenSet({
		screenSet: screenSet,
		startScreen: startScreen,
		onHide: onHide || null,
		deviceType: "auto",
	});
};

export const login = (callback?: any): any => {
	gigyaActions("POC-FlujoComfamaID", "gigya-login-screen", callback);
	// gigyaActions("POC-RegistrationLogin", "gigya-login-screen", getUserData);
	// POC-RegistrationLoginID -> Login screen con estilos inestables
	// POC-RegistrationLogin -> Login screen con estilos un poco más estables
};

export const logout = () => {
	return new Promise((resolve, reject) => {
		gigya.accounts.logout({
			callback: (res: any) => {
				if (res.errorCode === RESPONSE_CODES.SUCCESS) resolve(res);
				else reject(res);
			},
		});
	});
};

const getUserDataInternal = () => {
	gigya.accounts.getAccountInfo({
		callback: (res: any) => {
			return res;
		},
	});
};

export const getUserData = () => {
	return new Promise((resolve, reject) => {
		gigya.accounts.getAccountInfo({
			callback: (res: any) => {
				if (res.errorCode === RESPONSE_CODES.SUCCESS) resolve(res);
				else reject(res);
			},
		});
	});
};

export const verifySession = () => {
	return new Promise((resolve, reject) => {
		gigya.accounts.session.verify({
			callback: (res: any) => {
				if (res.errorCode === RESPONSE_CODES.SUCCESS) resolve(res);
				else reject(res);
			},
		});
	});
};

export const getLocalToken = () => {
	return localStorage.getItem("mentoria-token");
};

export const generateToken = () => {
	return gigya.accounts.getJWT({
		callback: (res: any) => {
			localStorage.setItem("mentoria-token", res);
			return res;
		},
		fields: "UID,data.docNumber,data.docType,data.mobile,email,firstName,lastName,photoURL",
		expiration: 604800,
	});
};
